import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { serviceWorkerKaydet } from './utils/webPush';
// Yan etkisi için: `beforeinstallprompt` dinleyicisini React ağacı
// kurulmadan bağlar. Olay sayfa açılışında bir kez tetikleniyor ve
// kaçırılırsa bir daha gelmiyor (bkz. utils/pwaInstall).
import './utils/pwaInstall';

/*
 * SERVICE WORKER KAYDI UYGULAMA AÇILIŞINDA — BİR BİLEŞENİN İÇİNDE DEĞİL.
 *
 * Kayıt önce `BildirimIzniDugmesi` içindeydi. O düğme 22.09.2026'da
 * bildirim menüsünün (AntD `Popover`) içine taşındı ve Popover içeriğini
 * ANCAK AÇILINCA oluşturduğu için worker, kullanıcı zile basana kadar hiç
 * kaydolmaz oldu. Ölçüldü (23.09.2026): giriş yapılmış, VAPID tanımlı bir
 * oturumda `getRegistrations()` BOŞ dönüyordu.
 *
 * İki şey birden buna bağlı:
 *   - Push: worker olmadan abonelik kurulamıyor.
 *   - Yüklenebilirlik: Chrome "Uygulamayı yükle" seçeneğini ancak AKTİF bir
 *     service worker varken sunuyor, dolayısıyla `beforeinstallprompt` hiç
 *     tetiklenmiyor ve "Uygulamayı Yükle" düğmesi de hiç çizilmiyordu.
 *
 * Kayıt izin İSTEMİYOR (yalnızca worker'ı yüklüyor), o yüzden açılışta
 * yapılması sakıncasız — izin hâlâ kullanıcı dokunuşuyla isteniyor.
 * Desteklenmeyen tarayıcıda fonksiyon sessizce çıkıyor.
 */
serviceWorkerKaydet();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
